// import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
// import 'typeface-roboto';
// import Button from '@material-ui/core/Button';
// import Radio from '@material-ui/core/Radio';
// import RadioGroup from '@material-ui/core/RadioGroup';
import FormHelperText from '@material-ui/core/FormHelperText';
import Grid from '@material-ui/core/Grid';
import Step from '@material-ui/core/Step';
import StepContent from '@material-ui/core/StepContent';
import StepLabel from '@material-ui/core/StepLabel';
import Stepper from '@material-ui/core/Stepper';
import { withStyles } from '@material-ui/core/styles';
// import FormLabel from '@material-ui/core/FormLabel';
import Typography from '@material-ui/core/Typography';
import classnames from 'classnames';
import { Formik } from 'formik';
import React, { Component } from 'react';
import * as Yup from 'yup';
import { CardServicesMobile } from '../../CommonComponents';
import { SpecialRadioGroup, StepButtons } from '../CommonComponents';
import styles from '../ewccstyle';
import CreditCardReference from './CreditCardReference';
import EastWestBankClient from './EastWestBankClient';
// import TextField from '@material-ui/core/TextField';
// import InputLabel from '@material-ui/core/InputLabel';
// import Select from '@material-ui/core/Select';
import { Consumer } from './EWCCContext';
import PersonalInformation from './PersonalInformation';
import ReviewDetail from './ReviewDetail';
import SpouseInfromation from './SpouseInformation';
import TradeReference from './TradeReference';
import WorkAndFinances from './WorkAndFinances';

const ewcclist = [
    { value: "PCM", label: "EastWest Platinum Mastercard" },
    { value: "VPL", label: "EastWest Visa Platinum" },
    { value: "ECM", label: "EastWest EveryDay Titanium Mastercard" },
    { value: "DVN", label: "EastWest Dolce Vita Titanium Mastercard" },
    { value: "GCV", label: "EastWest Visa Gold" },
    { value: "GCM", label: "EastWest Gold Mastercard" },
    { value: "SCV", label: "EastWest Visa Classic" },
    { value: "SCM", label: "EastWest Classic Mastercard" },
    { value: "GPM", label: "EastWest Practical Mastercard" },
    { value: "", label: "EastWest Singapore Airlines KrisFlyer Platinum Mastercard" },
    { value: "HCM", label: "Hyundai Mastercard" },
    { value: "DLS", label: "DLSAA Mastercard" }
  ];

const SelectCreditCard = withStyles(styles)(function(props) {
    const { activeStep, handleBack, classes, productid, formval } = props;
    // console.log(typeof formval);
    return (
        <Consumer>
            {context => (
                // let tempinitval = "";
                <Formik
                    // initialValues = { {cardType: context.cardType} }
                    initialValues = { typeof formval !== 'undefined' ? {cardType: formval } : {cardType: context.cardType} }
                    validationSchema = { Yup.object().shape({
                        cardType: Yup.string().required('Type of EastWest Bank Credit Card is required'),
                    })}
                    onSubmit = {(values,actions) => {
                        // console.log('EWCC form submit handled!');
                        context.updateState("cardType", values.cardType);
                        actions.setSubmitting(false);
                        props.handleSubmit();
                    }}
                >
                    {props => {
                        const {
                            values,
                            errors,
                            touched,
                            handleBlur,
                            handleSubmit,
                            setFieldValue,
                            isSubmitting
                        } = props;
                        // console.log(values);
                        return(

                            <form noValidate autoComplete="off">

                                <FormControl
                                    fullWidth
                                    component="fieldset"
                                    // className={classes.formRadio}
                                    className={classes.formControl}
                                    error={errors.cardType && touched.cardType ? true : false}
                                >

                                    <SpecialRadioGroup
                                        name="cardType"
                                        value={values.cardType}
                                        onChange={setFieldValue}
                                        onBlur={handleBlur}
                                        options={ewcclist}
                                        formval={formval}
                                    />

                                    <FormHelperText
                                        margin="dense"
                                        classes={{
                                            root: classes.dropdownError,
                                            error: classes.error,
                                        }} component="p">
                                        {errors.cardType && touched.cardType && (<>{errors.cardType}</>)}
									</FormHelperText>
                                    {/* <FormHelperText>{errors.cardType && touched.cardType && (<p>{errors.cardType}</p>)}</FormHelperText> */}
                                </FormControl>

                                <br />

                                <Typography variant="body1">
                                Note: You may receive a card type other than your choice, depending on the result of EastWest’s evaluation of your application.
                                </Typography>

                                <StepButtons isSubmitting={isSubmitting} activestep={activeStep} handleBack={handleBack} handleNext={handleSubmit} />
                            </form>
                        )
                    }}
                </Formik>
            )}
        </Consumer>
    )
})

// function ReviewDetail(props) {
//     const { activeStep, isSubmitting,  handleBack, handleSubmit } = props;
//     return(
//         <Consumer>
//             {context => (
//                 <div>
//                     <p>Card type: {context.cardType}</p>
//                     <p>Deposit: {context.deposit}</p>
//                     <p>EwCC: {context.ewcc}</p>

//                     <StepButtons isSubmitting={isSubmitting} activestep={activeStep} handleBack={handleBack} handleNext={handleSubmit} />
//                 </div>
//             )}
//         </Consumer>

//     );
// }

function getSteps() {
    return [
        'My EastWest Credit Card (Please choose 1) ',
        'Existing EastWest Client',
        'My Personal Information',
        'My Work and Finances',
        'My Credit Card References',
        'My Spouse\'s Information',
        'My Personal / Trade Reference',
        'Review details'
    ];
}

// function ShowContent(props) {
//     const { step } = props;
//     switch (step) {
//         case 0:
//         return <SpouseInfromation {...props} />;
//         case 1:
//             return <ReviewDetail {...props} />;
//         // case 2:
//         //     return <PersonalInformation {...props} />;
//         // case 3:
//         //     return <WorkAndFinances {...props} />;
//         // case 4:
//         //     return <CreditCardReference {...props} />;
//         // case 5:
//         //     return <SpouseInfromation {...props} />;
//         // case 6:
//         //     return <TradeReference {...props} />;
//         // case 7:
//         //     return <ReviewDetail {...props} />;
//       default:
//         return 'Unknown step';
//     }
// }

function ShowContent(props) {
    const { step } = props;
    switch (step) {
        case 0:
            return <SelectCreditCard {...props} />;
        case 1:
            return <EastWestBankClient {...props} />;
        case 2:
            return <PersonalInformation {...props} />;
        case 3:
            return <WorkAndFinances {...props} />;
        case 4:
            return <CreditCardReference {...props} />;
        case 5:
            return <SpouseInfromation {...props} />;
        case 6:
            return <TradeReference {...props} />;
        case 7:
            return <ReviewDetail {...props} />;
      default:
        return 'Unknown step';
    }
}

class EWCCForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeStep: 0,
        }
    }


    handleNext = (ismax) => {
        // console.log('max: ' + ismax)
        if (!ismax) {
            this.setState(state => ({
                activeStep: state.activeStep + 1,
            }));
        } else {
            if (this.props.displayType === "desktop") {
                this.props.handleClose();
            }
        }
    };
    handleEdit = (step) => {
        this.setState(prevState => ({
          activeStep: prevState.activeStep - step,
        }));
        window.scrollTo(0, 0);
      };

    handleBack = () => {
        this.setState(state => ({
            activeStep: state.activeStep - 1,
        }));
    };

    render() {
        const { classes, productType, formval } = this.props;
        const steps = getSteps();
        const maxStep = steps.length - 1;
        const { activeStep } = this.state;
        // console.log(formval);
        return(
            <div className="gridContainer">
            <Grid container className={classnames(classes.spacer, classes.paperPadding)}>
                <Stepper activeStep={activeStep} orientation="vertical">
                    {steps.map((label, index) => {
                        return (
                            <Step key={label}>
                                <StepLabel classes={{
                                    iconContainer: classes.iconContainer,
                                    }}>{label}
                                </StepLabel>
                                <StepContent>
                                    <ShowContent
                                        formval={formval}
                                        productid={productType}
                                        handleEdit={this.handleEdit}
                                        step={index}
                                        handleBack={this.handleBack}
                                        handleSubmit={this.handleNext}
                                        activeStep={activeStep}
                                        maxStep={maxStep} />
                                </StepContent>
                            </Step>
                        );
                    })}
                </Stepper>

                </Grid>
      </div>
        );
    }
}

export default withStyles(styles)(EWCCForm);